var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          return [
            _c(
              "ui-modal",
              {
                attrs: { validated: false, closable: false },
                on: {
                  confirm: _vm.sendForm,
                  hidden: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              },
              [
                _c("div", { staticClass: "header" }, [
                  _vm._v("\n      " + _vm._s(_vm.$t("header")) + "\n    ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "ui form" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm._f("cap")(_vm.$t("labels.email"))))
                        ]),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { name: "email", rules: "required|email" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.feedback.email,
                                          expression: "feedback.email",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      attrs: {
                                        type: "email",
                                        placeholder: "my@email.com",
                                        required: ""
                                      },
                                      domProps: { value: _vm.feedback.email },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.feedback,
                                            "email",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { class: _vm.$style.error }, [
                                      _c("span", [_vm._v(_vm._s(errors[0]))])
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm._f("cap")(_vm.$t("labels.subject")))
                          )
                        ]),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { name: "subject", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.feedback.subject,
                                          expression: "feedback.subject",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t(
                                          "placeholder.subject"
                                        ),
                                        required: ""
                                      },
                                      domProps: { value: _vm.feedback.subject },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.feedback,
                                            "subject",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { class: _vm.$style.error }, [
                                      _c("span", [_vm._v(_vm._s(errors[0]))])
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm._f("cap")(_vm.$t("labels.content")))
                          )
                        ]),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          attrs: { name: "text", rules: "required|max:1000" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.feedback.text,
                                          expression: "feedback.text",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      ref: "textarea",
                                      class: _vm.$style.textarea,
                                      attrs: {
                                        rows: "5",
                                        placeholder: _vm.$t("placeholder.text")
                                      },
                                      domProps: { value: _vm.feedback.text },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.feedback,
                                            "text",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { class: _vm.$style.error }, [
                                      _c("span", [_vm._v(_vm._s(errors[0]))])
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ui deny button",
                      class: { disabled: _vm.pending }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("cap")(_vm.$t("buttons.cancel"))) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ui positive right labeled icon button",
                      class: {
                        loading: _vm.pending,
                        disabled: _vm.pending || invalid
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("cap")(_vm.$t("buttons.send"))) +
                          "\n        "
                      ),
                      _c("i", { staticClass: "checkmark icon" })
                    ]
                  )
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }